const navigateChange = (navigate, path, setDrawerOpen) => {
  navigate(path);
  setDrawerOpen(false);
};

const windowOpen = (url) => {
  window.open(url, "_blank", "noopener");
};

const createMainMenu = (setSelectedDrawer, setDrawerOpen, navigate) => {
  return [
    {
      name: "Products",
      action: () => {
        setSelectedDrawer("products");
        setDrawerOpen(true);
      },
      key: "products",
    },
    {
      name: "Industries",
      action: () => {
        setSelectedDrawer("industries");
        setDrawerOpen(true);
      },
      key: "industries",
    },
    {
      name: "Services",
      action: () => {
        setSelectedDrawer("services");
        setDrawerOpen(true);
      },
      key: "services",
    },
    {
      name: "Overview",
      action: () => {
        setSelectedDrawer("overview");
        setDrawerOpen(true);
      },
      key: "overview",
    },
    {
      name: "Careers",
      action: () => {
        setSelectedDrawer("careers");
        setDrawerOpen(true);
      },
      key: "careers",
    },
    {
      name: "Events",
      action: () =>
        windowOpen(
          "https://resources.nucleusteq.com/databrickssummit2025"
        ),
      key: "event",
    },
    {
      name: "Contact Us",
      action: () => {
        navigate("/contact");
      },
      key: "contact",
    },
    { name: "SPACE", action: null, hide: true },
  ];
};

const createSubMenu = (setDrawerOpen, navigate) => {
  const quickLinks = {
    title: {
      text: "Overview Links",
    },
    headings: [
      {
        text: "About Us",
        action: () => navigateChange(navigate, "/aboutUs", setDrawerOpen),
      },
      {
        text: "Leadership",
        action: () => navigateChange(navigate, "/leadership", setDrawerOpen),
      },
      {
        text: "Partners",
        action: () => navigateChange(navigate, "/partners", setDrawerOpen),
      },
      {
        text: "Customers",
        action: () => navigateChange(navigate, "/customers", setDrawerOpen),
      },
      {
        text: "Success Stories",
        action: () =>
          navigateChange(navigate, "/successStories", setDrawerOpen),
      },
    ],
  };

  return {
    products: [
      {
        title: { text: "Data Management & Engineering", action: () => {} },
        headings: [
          {
            text: "NuoData – Astra",
            action: () => windowOpen("https://www.nuodata.io/platforms/astra/"),
            subHeadings: [
              {
                text: "Data catalog, lineage, glossary, and governance platform",
                action: () =>
                  windowOpen("https://www.nuodata.io/platforms/astra/"),
              },
            ],
          },
          {
            text: "NuoData – Quantum",
            action: () =>
              windowOpen("https://www.nuodata.io/platforms/quantum/"),
            subHeadings: [
              {
                text: "Data ingestion & transformation platform",
                action: () =>
                  windowOpen("https://www.nuodata.io/platforms/quantum/"),
              },
            ],
          },
          {
            text: "NuoData – Maestro",
            action: () =>
              windowOpen("https://www.nuodata.io/platforms/maestro/"),
            subHeadings: [
              {
                text: "Data scheduling, orchestration, and event engine",
                action: () =>
                  windowOpen("https://www.nuodata.io/platforms/maestro/"),
              },
            ],
          },
          {
            text: "NuoData – Spectra",
            action: () =>
              windowOpen("https://www.nuodata.io/platforms/spectra/"),
            subHeadings: [
              {
                text: "Data operations & observability platform",
                action: () =>
                  windowOpen("https://www.nuodata.io/platforms/spectra/"),
              },
            ],
          },
          {
            text: "NuoData – Halo",
            action: () => windowOpen("https://www.nuodata.io/platforms/halo/"),
            subHeadings: [
              {
                text: "Authentication, authorization & security",
                action: () =>
                  windowOpen("https://www.nuodata.io/platforms/halo/"),
              },
            ],
          },
        ],
      },
      {
        title: { text: "Data Analytics, AI & ML", action: () => {} },
        headings: [
          {
            text: "Nova Gen AI",
            action: () =>
              windowOpen(
                "https://www.nuodata.io/platforms/nova/gen-ai/"
              ),
            subHeadings: [
              {
                text: "Gen AI, inference AI, RAG agents",
                action: () =>
                  windowOpen(
                    "https://www.nuodata.io/platforms/nova/gen-ai/"
                  ),
              },
            ],
          },
          {
            text: "Nova AI/ML",
            action: () => windowOpen("https://www.nuodata.io/platforms/nova/ai-and-ml/"),
            subHeadings: [
              {
                text: "AI/ML, analytics as a service platform",
                action: () =>
                  windowOpen("https://www.nuodata.io/platforms/nova/ai-and-ml/"),
              },
            ],
          },
          {
            text: "NuoData – Notebook",
            action: () => windowOpen("https://www.nuodata.io/platforms/nova/ai-and-ml/"),
            subHeadings: [
              {
                text: "Jupyter Notebook as a service",
                action: () =>
                  windowOpen("https://www.nuodata.io/platforms/nova/ai-and-ml/"),
              },
            ],
          },
        ],
      },
      {
        title: { text: "Data Modernization", action: () => {} },
        headings: [
          {
            text: "NuoData – TransformX",

            subHeadings: [
              {
                text: "Data modernization & migration",
                action: () =>
                  windowOpen("https://www.nuodata.io/platforms/transform-x/"),
              },
              {
                text: "Informatica to Spark on any cloud",
                action: () =>
                  windowOpen("https://www.nuodata.io/platforms/transform-x/"),
              },
              {
                text: "Informatica to Databricks",
                action: () =>
                  windowOpen(
                    "https://www.nuodata.io/platforms/informatica-to-databricks/"
                  ),
              },
              {
                text: "Hadoop to any cloud",
                action: () =>
                  windowOpen("https://www.nuodata.io/platforms/transform-x/"),
              },
              {
                text: "SSIS, SP & SQL to Spark on any cloud",
                action: () =>
                  windowOpen("https://www.nuodata.io/platforms/transform-x/"),
              },
            ],
          },
        ],
      },
    ],
    industries: [
      {
        title: {
          text: "Industries",
        },
        headings: [
          {
            text: "Banking & Financial",
            action: () => navigateChange(navigate, "/bank", setDrawerOpen),
          },
          {
            text: "Retail, Consumer Goods & Services",
            action: () => navigateChange(navigate, "/retail", setDrawerOpen),
          },
          {
            text: "Insurance",
            action: () => navigateChange(navigate, "/insurance", setDrawerOpen),
          },
          {
            text: "Life Sciences & Healthcare",
            action: () => navigateChange(navigate, "/life", setDrawerOpen),
          },
          {
            text: "Communication, Media & Technology",
            action: () =>
              navigateChange(navigate, "/communication", setDrawerOpen),
          },
          {
            text: "Energy & Utilities",
            action: () => navigateChange(navigate, "/energy", setDrawerOpen),
          },
          {
            text: "Travel & Hospitality",
            action: () => navigateChange(navigate, "/travel", setDrawerOpen),
          },
        ],
      },
      {
        ...quickLinks,
        title: {
          text: "Quick Links",
        },
      },
    ],
    services: [
      {
        title: {
          text: "Enterprise AI",
        },
        headings: [
          {
            text: "Generative AI & Agentic workflow Engineering",
            action: () => {
              navigateChange(navigate, "/service/enterprise-ai/#generative-ai", setDrawerOpen);
            },
            subHeadings: [
              {
                text: "Transform operations with generative AI, automating workflows and creating personalized content to drive efficiency and engagement.",
                action: () => {
                  navigateChange(
                    navigate,
                    "/service/enterprise-ai/#generative-ai",
                    setDrawerOpen
                  );
                },
              },
            ],
          },
          {
            text: "Multi Modal AI Development",
            action: () => {
              navigateChange(navigate, "/service/enterprise-ai/#multi-modal-ai", setDrawerOpen);
            },
            subHeadings: [
              {
                text: "Create AI systems integrating vision, audio, and code generation for versatile, intelligent applications across industries.",
                action: () => {
                  navigateChange(
                    navigate,
                    "/service/enterprise-ai/#multi-modal-ai",
                    setDrawerOpen
                  );
                },
              },
            ],
          },
          {
            text: "Conversational AI Development",
            action: () => {
              navigateChange(navigate, "/service/enterprise-ai/#conversational-ai", setDrawerOpen);
            },
            subHeadings: [
              {
                text: "Enhance customer interactions with intelligent chatbots, delivering faster responses and personalized support.",
                action: () => {
                  navigateChange(
                    navigate,
                    "/service/enterprise-ai/#conversational-ai",
                    setDrawerOpen
                  );
                },
              },
            ],
          },
          {
            text: "ML Engineering",
            action: () => {
              navigateChange(navigate, "/service/enterprise-ai/#ml-engineering", setDrawerOpen);
            },
            subHeadings: [
              {
                text: "Build custom ML models for predictive maintenance and fraud detection, ensuring high accuracy and operational efficiency.",
                action: () => {
                  navigateChange(
                    navigate,
                    "/service/enterprise-ai/#ml-engineering",
                    setDrawerOpen
                  );
                },
              },
            ],
          },
          {
            text: "Industry-Specific AI Solutions",
            action: () => {
              navigateChange(navigate, "/service/enterprise-ai/#industry-ai", setDrawerOpen);
            },
            subHeadings: [
              {
                text: "Deploy tailored AI models for sectors like manufacturing and BFSI, optimizing processes while meeting regulatory standards.",
                action: () => {
                  navigateChange(
                    navigate,
                    "/service/enterprise-ai/#industry-ai",
                    setDrawerOpen
                  );
                },
              },
            ],
          },
          {
            text: "AI Strategy Consulting",
            action: () => {
              navigateChange(navigate, "/service/enterprise-ai/#ai-strategy", setDrawerOpen);
            },
            subHeadings: [
              {
                text: "Develop AI roadmaps and identify high-impact use cases to accelerate adoption and drive business value.",
                action: () => {
                  navigateChange(
                    navigate,
                    "/service/enterprise-ai/#ai-strategy",
                    setDrawerOpen
                  );
                },
              },
            ],
          },
          {
            text: "Generative BI",
            action: () => {
              navigateChange(navigate, "/service/enterprise-ai/#generative-bi", setDrawerOpen);
            },
            subHeadings: [
              {
                text: "Unlock strategic insights with AI-driven predictive dashboards and automated reporting, boosting revenue and decision speed.",
                action: () => {
                  navigateChange(
                    navigate,
                    "/service/enterprise-ai/#generative-bi",
                    setDrawerOpen
                  );
                },
              },
            ],
          },
          {
            text: "Gen AI & ML Compliance",
            action: () => {
              navigateChange(navigate, "/service/enterprise-ai/#ai-compliance", setDrawerOpen);
            },
            subHeadings: [
              {
                text: "Ensure ethical AI with compliance frameworks, bias mitigation, and transparent models for regulatory adherence.",
                action: () => {
                  navigateChange(
                    navigate,
                    "/service/enterprise-ai/#ai-compliance",
                    setDrawerOpen
                  );
                },
              },
            ],
          },
          {
            text: "ML/LLM Ops",
            action: () => {
              navigateChange(navigate, "/service/enterprise-ai/#mlops", setDrawerOpen);
            },
            subHeadings: [
              {
                text: "Streamline AI operations with automated pipelines and monitoring, ensuring high uptime and rapid deployments.",
                action: () => {
                  navigateChange(
                    navigate,
                    "/service/enterprise-ai/#mlops",
                    setDrawerOpen
                  );
                },
              },
            ],
          },
          {
            text: "LLM Deployment",
            action: () => {
              navigateChange(navigate, "/service/enterprise-ai/#llm-deployment", setDrawerOpen);
            },
            subHeadings: [
              {
                text: "Deploy large language models on cloud platforms for scalable, high-performance AI applications.",
                action: () => {
                  navigateChange(
                    navigate,
                    "/service/enterprise-ai/#llm-deployment",
                    setDrawerOpen
                  );
                },
              },
            ],
          },
          {
            text: "Predictive Analytics Solutions",
            action: () => {
              navigateChange(navigate, "/service/enterprise-ai/#predictive-analytics", setDrawerOpen);
            },
            subHeadings: [
              {
                text: "Develop predictive models to forecast trends and drive strategic decisions with high accuracy.",
                action: () => {
                  navigateChange(
                    navigate,
                    "/service/enterprise-ai/#predictive-analytics",
                    setDrawerOpen
                  );
                },
              },
            ],
          },
          {
            text: "Model Monitoring & Retraining",
            action: () => {
              navigateChange(navigate, "/service/enterprise-ai/#model-monitoring", setDrawerOpen);
            },
            subHeadings: [
              {
                text: "Monitor and retrain AI models in real-time to maintain performance and adapt to changing data patterns.",
                action: () => {
                  navigateChange(
                    navigate,
                    "/service/enterprise-ai/#model-monitoring",
                    setDrawerOpen
                  );
                },
              },
            ],
          },
        ],
      },
      {
        title: {
          text: "Data & AI Strategy Consulting",
        },
        headings: [
          {
            text: "Cloud & Data Architecture Consulting",
            action: () => {
              navigateChange(navigate, "/service/data-strategy/#cloud-architecture", setDrawerOpen);
            },
            subHeadings: [
              {
                text: "Design scalable, multi-cloud architectures to enhance data processing and support enterprise analytics, achieving up to 5X performance gains.",
                action: () => {
                  navigateChange(
                    navigate,
                    "/service/data-strategy/#cloud-architecture",
                    setDrawerOpen
                  );
                },
              },
            ],
          },
          {
            text: "Data Lake & Warehouse Planning",
            action: () => {
              navigateChange(navigate, "/service/data-strategy/#data-lake-planning", setDrawerOpen);
            },
            subHeadings: [
              {
                text: "Plan and implement data lakes and warehouses to centralize and optimize data storage for advanced analytics and reporting.",
                action: () => {
                  navigateChange(
                    navigate,
                    "/service/data-strategy/#data-lake-planning",
                    setDrawerOpen
                  );
                },
              },
            ],
          },
          {
            text: "Real-Time Pipeline Consulting",
            action: () => {
              navigateChange(navigate, "/service/data-strategy/#pipeline-consulting", setDrawerOpen);
            },
            subHeadings: [
              {
                text: "Create real-time data pipelines to enable dynamic analytics and decision-making with low-latency processing.",
                action: () => {
                  navigateChange(
                    navigate,
                    "/service/data-strategy/#pipeline-consulting",
                    setDrawerOpen
                  );
                },
              },
            ],
          },
          {
            text: "Cost Optimization Assessments",
            action: () => {
              navigateChange(navigate, "/service/data-strategy/#cost-optimization", setDrawerOpen);
            },
            subHeadings: [
              {
                text: "Conduct cost audits to optimize cloud and data resources, maximizing ROI and operational efficiency.",
                action: () => {
                  navigateChange(
                    navigate,
                    "/service/data-strategy/#cost-optimization",
                    setDrawerOpen
                  );
                },
              },
            ],
          },
          {
            text: "Gen AI & ML Consulting",
            action: () => {
              navigateChange(navigate, "/service/data-strategy/#gen-ai-consulting", setDrawerOpen);
            },
            subHeadings: [
              {
                text: "Develop AI and ML strategies to reduce time-to-value and drive innovation through high-impact use cases.",
                action: () => {
                  navigateChange(
                    navigate,
                    "/service/data-strategy/#gen-ai-consulting",
                    setDrawerOpen
                  );
                },
              },
            ],
          },
          {
            text: "AI Integration Roadmaps",
            action: () => {
              navigateChange(navigate, "/service/data-strategy/#ai-integration", setDrawerOpen);
            },
            subHeadings: [
              {
                text: "Design seamless AI integration strategies to ensure interoperability and scalability across enterprise systems.",
                action: () => {
                  navigateChange(
                    navigate,
                    "/service/data-strategy/#ai-integration",
                    setDrawerOpen
                  );
                },
              },
            ],
          },
          {
            text: "AI Adoption Consulting",
            action: () => {
              navigateChange(navigate, "/service/data-strategy/#ai-adoption", setDrawerOpen);
            },
            subHeadings: [
              {
                text: "Facilitate enterprise-wide AI adoption through change management and stakeholder engagement.",
                action: () => {
                  navigateChange(
                    navigate,
                    "/service/data-strategy/#ai-adoption",
                    setDrawerOpen
                  );
                },
              },
            ],
          },
          {
            text: "Business Consulting",
            action: () => {
              navigateChange(navigate, "/service/data-strategy/#business-consulting", setDrawerOpen);
            },
            subHeadings: [
              {
                text: "Align data and AI initiatives with business goals to drive revenue growth and strategic outcomes.",
                action: () => {
                  navigateChange(
                    navigate,
                    "/service/data-strategy/#business-consulting",
                    setDrawerOpen
                  );
                },
              },
            ],
          },
          {
            text: "ROI Analysis Services",
            action: () => {
              navigateChange(navigate, "/service/data-strategy/#roi-analysis", setDrawerOpen);
            },
            subHeadings: [
              {
                text: "Quantify the financial impact of data and AI initiatives to optimize investments and drive value.",
                action: () => {
                  navigateChange(
                    navigate,
                    "/service/data-strategy/#roi-analysis",
                    setDrawerOpen
                  );
                },
              },
            ],
          },
          {
            text: "Governance Strategy Consulting",
            action: () => {
              navigateChange(navigate, "/service/data-strategy/#governance-consulting", setDrawerOpen);
            },
            subHeadings: [
              {
                text: "Design data governance frameworks to ensure compliance and data integrity across enterprise operations.",
                action: () => {
                  navigateChange(
                    navigate,
                    "/service/data-strategy/#governance-consulting",
                    setDrawerOpen
                  );
                },
              },
            ],
          },
        ],
      },
      {
        title: {
          text: "Data Engineering & Governance",
        },
        headings: [
          {
            text: "Data Platform Engineering",
            action: () => {
              navigateChange(
                navigate,
                "/service/data-management/#data-platform",
                setDrawerOpen
              );
            },
            subHeadings: [
              {
                text: "Transform operations with generative AI, automating workflows and creating personalized content to drive efficiency and engagement.",
                action: () => {
                  navigateChange(
                    navigate,
                    "/service/data-management/#data-platform",
                    setDrawerOpen
                  );
                },
              },
            ],
          },
          {
            text: "Advanced Data Integration & Pipeline Engineering",
            action: () => {
              navigateChange(
                navigate,
                "/service/data-management/#data-integration",
                setDrawerOpen
              );
            },
            subHeadings: [
              {
                text: "Design fault-tolerant, scalable pipelines for batch and real-time data integration, unifying diverse sources with optimized performance.",
                action: () => {
                  navigateChange(
                    navigate,
                    "/service/data-management/#data-integration",
                    setDrawerOpen
                  );
                },
              },
            ],
          },
          {
            text: "Security & Governance Frameworks",
            action: () => {
              navigateChange(
                navigate,
                "/service/data-management/#security-governance",
                setDrawerOpen
              );
            },
            subHeadings: [
              {
                text: "Implement robust frameworks for data security, compliance, and governance, ensuring regulatory adherence and integrity.",
                action: () => {
                  navigateChange(
                    navigate,
                    "/service/data-management/#security-governance",
                    setDrawerOpen
                  );
                },
              },
            ],
          },
          {
            text: "CloudOps & DataOps Automation",
            action: () => {
              navigateChange(
                navigate,
                "/service/data-management/#cloudops-dataops",
                setDrawerOpen
              );
            },
            subHeadings: [
              {
                text: "Build custom ML models for predictive maintenance and fraud detection, ensuring high accuracy and operational efficiency.",
                action: () => {
                  navigateChange(
                    navigate,
                    "/service/data-management/#cloudops-dataops",
                    setDrawerOpen
                  );
                },
              },
            ],
          },
          {
            text: "Pipeline Observability & Optimization",
            action: () => {
              navigateChange(
                navigate,
                "/service/data-management/#observability-optimization",
                setDrawerOpen
              );
            },
            subHeadings: [
              {
                text: "Enable real-time pipeline monitoring, anomaly detection, and performance optimization for complete visibility and reliability.",
                action: () => {
                  navigateChange(
                    navigate,
                    "/service/data-management/#observability-optimization",
                    setDrawerOpen
                  );
                },
              },
            ],
          },
          {
            text: "Data Quality Engineering",
            action: () => {
              navigateChange(
                navigate,
                "/service/data-management/#data-quality",
                setDrawerOpen
              );
            },
            subHeadings: [
              {
                text: "Engineer automated data quality solutions with validation, anomaly detection, and testing to ensure enterprise-grade reliability.",
                action: () => {
                  navigateChange(
                    navigate,
                    "/service/data-management/#data-quality",
                    setDrawerOpen
                  );
                },
              },
            ],
          },
          {
            text: "Scalable Data Pipeline Architecture",
            action: () => {
              navigateChange(
                navigate,
                "/service/data-management/#scalable-pipeline",
                setDrawerOpen
              );
            },
            subHeadings: [
              {
                text: "Design scalable pipeline architectures to handle high data volumes with fault tolerance and optimized performance.",
                action: () => {
                  navigateChange(
                    navigate,
                    "/service/data-management/#scalable-pipeline",
                    setDrawerOpen
                  );
                },
              },
            ],
          },
          {
            text: "Data Pipeline Security",
            action: () => {
              navigateChange(
                navigate,
                "/service/data-management/#pipeline-security",
                setDrawerOpen
              );
            },
            subHeadings: [
              {
                text: "Implement advanced security measures to protect data pipelines from threats and ensure compliance.",
                action: () => {
                  navigateChange(
                    navigate,
                    "/service/data-management/#pipeline-security",
                    setDrawerOpen
                  );
                },
              },
            ],
          },
          {
            text: "Real-Time Analytics Enablement",
            action: () => {
              navigateChange(
                navigate,
                "/service/data-management/#real-time-analytics",
                setDrawerOpen
              );
            },
            subHeadings: [
              {
                text: "Enable real-time analytics with streaming pipelines for dynamic, low-latency insights.",
                action: () => {
                  navigateChange(
                    navigate,
                    "/service/data-management/#real-time-analytics",
                    setDrawerOpen
                  );
                },
              },
            ],
          },
          {
            text: "Data Lake Optimization",
            action: () => {
              navigateChange(
                navigate,
                "/service/data-management/#data-lake-optimization",
                setDrawerOpen
              );
            },
            subHeadings: [
              {
                text: "Optimize data lakes for performance, cost efficiency, and advanced analytics integration.",
                action: () => {
                  navigateChange(
                    navigate,
                    "/service/data-management/#data-lake-optimization",
                    setDrawerOpen
                  );
                },
              },
            ],
          },
          {
            text: "Data Warehouse Analytics",
            action: () => {
              navigateChange(
                navigate,
                "/service/data-management/#data-warehouse-analytics",
                setDrawerOpen
              );
            },
            subHeadings: [
              {
                text: "Develop predictive models to forecast trends and drive strategic decisions with high accuracy.",
                action: () => {
                  navigateChange(
                    navigate,
                    "/service/data-management/#data-warehouse-analytics",
                    setDrawerOpen
                  );
                },
              },
            ],
          },
          {
            text: "Compliance Monitoring",
            action: () => {
              navigateChange(
                navigate,
                "/service/data-management/#compliance-monitoring",
                setDrawerOpen
              );
            },
            subHeadings: [
              {
                text: "Automate real-time compliance monitoring to ensure continuous regulatory adherence with minimal effort.",
                action: () => {
                  navigateChange(
                    navigate,
                    "/service/data-management/#compliance-monitoring",
                    setDrawerOpen
                  );
                },
              },
            ],
          },
          {
            text: "Observability",
            action: () => {
              navigateChange(
                navigate,
                "/service/data-management/#dataops-visualization",
                setDrawerOpen
              );
            },
            subHeadings: [
              {
                text: "Develop end-to-end monitoring, alerting & interactive visualization dashboards for DataOps & Data Ops insights, enhancing pipeline management and decision-making.",
                action: () => {
                  navigateChange(
                    navigate,
                    "/service/data-management/#dataops-visualization",
                    setDrawerOpen
                  );
                },
              },
            ],
          },
          {
            text: "Operational Performance Consulting",
            action: () => {
              navigateChange(
                navigate,
                "/service/data-management/#operational-performance",
                setDrawerOpen
              );
            },
            subHeadings: [
              {
                text: "Optimize data operations through performance audits and advanced analytics to drive efficiency and cost savings.",
                action: () => {
                  navigateChange(
                    navigate,
                    "/service/data-management/#operational-performance",
                    setDrawerOpen
                  );
                },
              },
            ],
          },
        ],
      },
      {
        title: {
          text: "Data Consumption & Analytics",
        },
        headings: [
          {
            text: "Reporting & BI",
            action: () => {
              navigateChange(
                navigate,
                "/service/data-analytics/#reporting-bi",
                setDrawerOpen
              );
            },
            subHeadings: [
              {
                text: "Scalable BI pipelines deliver real-time, high-performance reporting with fault-tolerant analytics.",
                action: () => {
                  navigateChange(
                    navigate,
                    "/service/data-analytics/#reporting-bi",
                    setDrawerOpen
                  );
                },
              },
            ],
          },
          {
            text: "Custom Dashboard Development",
            action: () => {
              navigateChange(
                navigate,
                "/service/data-analytics/#custom-dashboards",
                setDrawerOpen
              );
            },
            subHeadings: [
              {
                text: "High-performance custom dashboards provide real-time, tailored analytics for enterprise stakeholders.",
                action: () => {
                  navigateChange(
                    navigate,
                    "/service/data-analytics/#custom-dashboards",
                    setDrawerOpen
                  );
                },
              },
            ],
          },
          {
            text: "Self-Service BI Implementation",
            action: () => {
              navigateChange(
                navigate,
                "/service/data-analytics/#self-service-bi",
                setDrawerOpen
              );
            },
            subHeadings: [
              {
                text: "Scalable self-service BI platforms empower users with automated, real-time analytics access.",
                action: () => {
                  navigateChange(
                    navigate,
                    "/service/data-analytics/#self-service-bi",
                    setDrawerOpen
                  );
                },
              },
            ],
          },
          {
            text: "Cross-Functional Reporting",
            action: () => {
              navigateChange(
                navigate,
                "/service/data-analytics/#cross-functional-reporting",
                setDrawerOpen
              );
            },
            subHeadings: [
              {
                text: "Integrated reporting systems unify departmental data for real-time, scalable cross-functional insights.",
                action: () => {
                  navigateChange(
                    navigate,
                    "/service/data-analytics/#cross-functional-reporting",
                    setDrawerOpen
                  );
                },
              },
            ],
          },
          {
            text: "BI Strategy Consulting",
            action: () => {
              navigateChange(
                navigate,
                "/service/data-analytics/#bi-strategy",
                setDrawerOpen
              );
            },
            subHeadings: [
              {
                text: "Engineering-driven BI strategies optimize pipelines, aligning insights with KPIs for maximum ROI.",
                action: () => {
                  navigateChange(
                    navigate,
                    "/service/data-analytics/#bi-strategy",
                    setDrawerOpen
                  );
                },
              },
            ],
          },
          {
            text: "Generative BI",
            action: () => {
              navigateChange(
                navigate,
                "/service/data-analytics/#generative-bi",
                setDrawerOpen
              );
            },
            subHeadings: [
              {
                text: "AI-driven BI pipelines deliver automated predictive and prescriptive insights for enterprise agility.",
                action: () => {
                  navigateChange(
                    navigate,
                    "/service/data-analytics/#generative-bi",
                    setDrawerOpen
                  );
                },
              },
            ],
          },
          {
            text: "Predictive Analytics Solutions",
            action: () => {
              navigateChange(
                navigate,
                "/service/data-analytics/#predictive-analytics",
                setDrawerOpen
              );
            },
            subHeadings: [
              {
                text: "Scalable predictive models with fault-tolerant pipelines ensure accurate forecasting for enterprises.",
                action: () => {
                  navigateChange(
                    navigate,
                    "/service/data-analytics/#predictive-analytics",
                    setDrawerOpen
                  );
                },
              },
            ],
          },
          {
            text: "BI Optimization Consulting",
            action: () => {
              navigateChange(
                navigate,
                "/service/data-analytics/#bi-optimization",
                setDrawerOpen
              );
            },
            subHeadings: [
              {
                text: "Optimize BI pipelines for performance, scalability, and fault tolerance, ensuring efficient analytics workflows.",
                action: () => {
                  navigateChange(
                    navigate,
                    "/service/data-analytics/#bi-optimization",
                    setDrawerOpen
                  );
                },
              },
            ],
          },
          {
            text: "Data Mesh Architecture",
            action: () => {
              navigateChange(
                navigate,
                "/service/data-analytics/#data-mesh-architecture",
                setDrawerOpen
              );
            },
            subHeadings: [
              {
                text: "Decentralized, scalable data mesh enables real-time analytics across distributed enterprise systems.",
                action: () => {
                  navigateChange(
                    navigate,
                    "/service/data-analytics/#data-mesh-architecture",
                    setDrawerOpen
                  );
                },
              },
            ],
          },
          {
            text: "API Development",
            action: () => {
              navigateChange(
                navigate,
                "/service/data-analytics/#api-development",
                setDrawerOpen
              );
            },
            subHeadings: [
              {
                text: "Scalable REST/GraphQL APIs enable real-time data consumption with secure, low-latency connectivity.",
                action: () => {
                  navigateChange(
                    navigate,
                    "/service/data-analytics/#api-development",
                    setDrawerOpen
                  );
                },
              },
            ],
          },
          {
            text: "Microservices Integration",
            action: () => {
              navigateChange(
                navigate,
                "/service/data-analytics/#microservices-integration",
                setDrawerOpen
              );
            },
            subHeadings: [
              {
                text: "Microservices frameworks enable scalable, real-time data consumption across distributed enterprise systems.",
                action: () => {
                  navigateChange(
                    navigate,
                    "/service/data-analytics/#microservices-integration",
                    setDrawerOpen
                  );
                },
              },
            ],
          },
        ],
      },
      {
        title: {
          text: "Data Modernization",
        },
        headings: [
          {
            text: "Legacy Data Modernization",
            action: () => {
              navigateChange(
                navigate,
                "/service/data-modernization/#data-modernization-migration",
                setDrawerOpen
              );
            },
            subHeadings: [
              {
                text: "Modernize legacy systems with cloud migration, achieving 8X faster timelines and 100% data integrity.",
                action: () => {
                  navigateChange(
                    navigate,
                    "/service/data-modernization/#data-modernization-migration",
                    setDrawerOpen
                  );
                },
              },
            ],
          },
          {
            text: "Data Pipeline Modernization",
            action: () => {
              navigateChange(
                navigate,
                "/service/data-modernization/#pipeline-modernization",
                setDrawerOpen
              );
            },
            subHeadings: [
              {
                text: "Modernize data pipelines with Spark and Airflow for enhanced performance and scalability.",
                action: () => {
                  navigateChange(
                    navigate,
                    "/service/data-modernization/#pipeline-modernization",
                    setDrawerOpen
                  );
                },
              },
            ],
          },
          {
            text: "Cloud Migration Consulting",
            action: () => {
              navigateChange(
                navigate,
                "/service/data-modernization/#cloud-migration-consulting",
                setDrawerOpen
              );
            },
            subHeadings: [
              {
                text: "Strategic cloud migration plans ensure seamless transitions with minimal disruption.",
                action: () => {
                  navigateChange(
                    navigate,
                    "/service/data-modernization/#cloud-migration-consulting",
                    setDrawerOpen
                  );
                },
              },
            ],
          },
          {
            text: "Data Integrity Validation",
            action: () => {
              navigateChange(
                navigate,
                "/service/data-modernization/#data-integrity",
                setDrawerOpen
              );
            },
            subHeadings: [
              {
                text: "Automated validation ensures 100% data integrity during cloud migrations.",
                action: () => {
                  navigateChange(
                    navigate,
                    "/service/data-modernization/#data-integrity",
                    setDrawerOpen
                  );
                },
              },
            ],
          },
          {
            text: "Informatica to Spark/Databricks/Cloud",
            action: () => {
              navigateChange(
                navigate,
                "/service/data-modernization/#informatica-spark",
                setDrawerOpen
              );
            },
            subHeadings: [
              {
                text: "Convert Informatica workflows to Spark on Databricks or any cloud for 5X performance and 80% reduced migration time.",
                action: () => {
                  navigateChange(
                    navigate,
                    "/service/data-modernization/#informatica-spark",
                    setDrawerOpen
                  );
                },
              },
            ],
          },
          {
            text: "Real-Time Analytics Enablement",
            action: () => {
              navigateChange(
                navigate,
                "/service/data-modernization/#real-time-analytics",
                setDrawerOpen
              );
            },
            subHeadings: [
              {
                text: "AI-driven BI pipelines deliver automated predictive and prescriptive insights for enterprise agility.",
                action: () => {
                  navigateChange(
                    navigate,
                    "/service/data-modernization/#real-time-analytics",
                    setDrawerOpen
                  );
                },
              },
            ],
          },
          {
            text: "Migration Automation",
            action: () => {
              navigateChange(
                navigate,
                "/service/data-modernization/#migration-automation",
                setDrawerOpen
              );
            },
            subHeadings: [
              {
                text: "Automate migrations with Databricks workflows to streamline processes and reduce effort.",
                action: () => {
                  navigateChange(
                    navigate,
                    "/service/data-modernization/#migration-automation",
                    setDrawerOpen
                  );
                },
              },
            ],
          },
          {
            text: "Performance Optimization Consulting",
            action: () => {
              navigateChange(
                navigate,
                "/service/data-modernization/#performance-optimization",
                setDrawerOpen
              );
            },
            subHeadings: [
              {
                text: "Optimize data pipelines for 5X performance through strategic consulting and advanced tools.",
                action: () => {
                  navigateChange(
                    navigate,
                    "/service/data-modernization/#performance-optimization",
                    setDrawerOpen
                  );
                },
              },
            ],
          },
          {
            text: "Hadoop to Cloud Modernization",
            action: () => {
              navigateChange(
                navigate,
                "/service/data-modernization/#hadoop-cloud",
                setDrawerOpen
              );
            },
            subHeadings: [
              {
                text: "Migrate Hadoop clusters to cloud for 10X performance and 70% cost savings.",
                action: () => {
                  navigateChange(
                    navigate,
                    "/service/data-modernization/#hadoop-cloud",
                    setDrawerOpen
                  );
                },
              },
            ],
          },
          {
            text: "Cost Optimization Services",
            action: () => {
              navigateChange(
                navigate,
                "/service/data-modernization/#cost-optimization",
                setDrawerOpen
              );
            },
            subHeadings: [
              {
                text: "Optimize cloud costs with AWS Trusted Advisor for maximum ROI and efficiency.",
                action: () => {
                  navigateChange(
                    navigate,
                    "/service/data-modernization/#cost-optimization",
                    setDrawerOpen
                  );
                },
              },
            ],
          },
          {
            text: "Performance Tuning",
            action: () => {
              navigateChange(
                navigate,
                "/service/data-modernization/#performance-tuning",
                setDrawerOpen
              );
            },
            subHeadings: [
              {
                text: "Tune Hadoop clusters with Spark and Hive for optimized performance and scalability.",
                action: () => {
                  navigateChange(
                    navigate,
                    "/service/data-modernization/#performance-tuning",
                    setDrawerOpen
                  );
                },
              },
            ],
          },
          {
            text: "Migration Strategy Consulting",
            action: () => {
              navigateChange(
                navigate,
                "/service/data-modernization/#migration-strategy",
                setDrawerOpen
              );
            },
            subHeadings: [
              {
                text: "Design Hadoop-to-cloud migration roadmaps for seamless, high-performance transitions.",
                action: () => {
                  navigateChange(
                    navigate,
                    "/service/data-modernization/#migration-strategy",
                    setDrawerOpen
                  );
                },
              },
            ],
          },
          {
            text: "SSIS/SP/SQL to Spark",
            action: () => {
              navigateChange(
                navigate,
                "/service/data-modernization/#ssis-sql-spark",
                setDrawerOpen
              );
            },
            subHeadings: [
              {
                text: "Convert SSIS and SQL workflows to Spark for 3X faster queries and 60% lower costs.",
                action: () => {
                  navigateChange(
                    navigate,
                    "/service/data-modernization/#ssis-sql-spark",
                    setDrawerOpen
                  );
                },
              },
            ],
          },
          {
            text: "SQL to Spark Conversion",
            action: () => {
              navigateChange(
                navigate,
                "/service/data-modernization/#sql-spark",
                setDrawerOpen
              );
            },
            subHeadings: [
              {
                text: "Migrate SQL stored procedures to Spark SQL for faster, scalable analytics.",
                action: () => {
                  navigateChange(
                    navigate,
                    "/service/data-modernization/#sql-spark",
                    setDrawerOpen
                  );
                },
              },
            ],
          },
          {
            text: "Modernization Consulting",
            action: () => {
              navigateChange(
                navigate,
                "/service/data-modernization/#modernization-consulting",
                setDrawerOpen
              );
            },
            subHeadings: [
              {
                text: "Design SQL-to-Spark strategies to modernize data ecosystems and boost analytics.",
                action: () => {
                  navigateChange(
                    navigate,
                    "/service/data-modernization/#modernization-consulting",
                    setDrawerOpen
                  );
                },
              },
            ],
          },
        ],
      },
      {
        title: {
          text: "Customer Experience & Digital Transformation",
        },
        headings: [
          {
            text: "Customer Experience",
            action: () => {
              navigateChange(
                navigate,
                "/service/customer-experience/#customer-experience",
                setDrawerOpen
              );
            },
            subHeadings: [
              {
                text: "Design personalized, omnichannel customer journeys to enhance engagement and satisfaction.",
                action: () => {
                  navigateChange(
                    navigate,
                    "/service/customer-experience/#customer-experience",
                    setDrawerOpen
                  );
                },
              },
            ],
          },
          {
            text: "Customer 360 Implementation",
            action: () => {
              navigateChange(
                navigate,
                "/service/customer-experience/#customer-360",
                setDrawerOpen
              );
            },
            subHeadings: [
              {
                text: "Build comprehensive customer views for unified, personalized experiences across platforms.",
                action: () => {
                  navigateChange(
                    navigate,
                    "/service/customer-experience/#customer-360",
                    setDrawerOpen
                  );
                },
              },
            ],
          },
          {
            text: "Behavioral Segmentation",
            action: () => {
              navigateChange(
                navigate,
                "/service/customer-experience/#behavioral-segmentation",
                setDrawerOpen
              );
            },
            subHeadings: [
              {
                text: "Deploy AI models for behavioral segmentation, enabling targeted customer experiences.",
                action: () => {
                  navigateChange(
                    navigate,
                    "/service/customer-experience/#behavioral-segmentation",
                    setDrawerOpen
                  );
                },
              },
            ],
          },
          {
            text: "Journey Mapping Services",
            action: () => {
              navigateChange(
                navigate,
                "/service/customer-experience/#journey-mapping",
                setDrawerOpen
              );
            },
            subHeadings: [
              {
                text: "Create detailed customer journey maps to optimize touchpoints and experiences.",
                action: () => {
                  navigateChange(
                    navigate,
                    "/service/customer-experience/#journey-mapping",
                    setDrawerOpen
                  );
                },
              },
            ],
          },
          {
            text: "CX Strategy Consulting",
            action: () => {
              navigateChange(
                navigate,
                "/service/customer-experience/#cx-strategy",
                setDrawerOpen
              );
            },
            subHeadings: [
              {
                text: "Design data-driven CX strategies to drive engagement and business outcomes.",
                action: () => {
                  navigateChange(
                    navigate,
                    "/service/customer-experience/#cx-strategy",
                    setDrawerOpen
                  );
                },
              },
            ],
          },
          {
            text: "Mobile App Development",
            action: () => {
              navigateChange(
                navigate,
                "/service/customer-experience/#mobile-app",
                setDrawerOpen
              );
            },
            subHeadings: [
              {
                text: "Develop high-performance mobile apps for seamless, scalable user experiences.",
                action: () => {
                  navigateChange(
                    navigate,
                    "/service/customer-experience/#mobile-app",
                    setDrawerOpen
                  );
                },
              },
            ],
          },
          {
            text: "Web UI Development",
            action: () => {
              navigateChange(
                navigate,
                "/service/customer-experience/#web-ui",
                setDrawerOpen
              );
            },
            subHeadings: [
              {
                text: "Build scalable web interfaces for intuitive, high-performance user experiences.",
                action: () => {
                  navigateChange(
                    navigate,
                    "/service/customer-experience/#web-ui",
                    setDrawerOpen
                  );
                },
              },
            ],
          },
          {
            text: "Accessibility Implementation",
            action: () => {
              navigateChange(
                navigate,
                "/service/customer-experience/#accessibility",
                setDrawerOpen
              );
            },
            subHeadings: [
              {
                text: "Ensure WCAG 2.1-compliant interfaces with ARIA labels for inclusive access.",
                action: () => {
                  navigateChange(
                    navigate,
                    "/service/customer-experience/#accessibility",
                    setDrawerOpen
                  );
                },
              },
            ],
          },
          {
            text: "Digital Transformation",
            action: () => {
              navigateChange(
                navigate,
                "/service/customer-experience/#digital-transformation",
                setDrawerOpen
              );
            },
            subHeadings: [
              {
                text: "Accelerate enterprise transformation with automation and cloud-native solutions for efficiency.",
                action: () => {
                  navigateChange(
                    navigate,
                    "/service/customer-experience/#digital-transformation",
                    setDrawerOpen
                  );
                },
              },
            ],
          },
          {
            text: "Digital Transformation Consulting",
            action: () => {
              navigateChange(
                navigate,
                "/service/customer-experience/#transformation-consulting",
                setDrawerOpen
              );
            },
            subHeadings: [
              {
                text: "Design digital transformation roadmaps with agile methodologies for business alignment.",
                action: () => {
                  navigateChange(
                    navigate,
                    "/service/customer-experience/#transformation-consulting",
                    setDrawerOpen
                  );
                },
              },
            ],
          },
        ],
      },
    ],
    overview: [
      {
        ...quickLinks,
      },
    ],
    careers: [
      {
        title: {
          text: "Careers",
        },
        headings: [
          {
            text: "Career Portal",
            action: () => windowOpen("https://nucleusteq.breezy.hr/"),
          },
          {
            text: "Career at Nucleusteq",
            action: () =>
              navigateChange(navigate, "/careerPage", setDrawerOpen),
          },
        ],
      },
      {
        ...quickLinks,
      },
    ],
  };
};

const activeMenu = (pathname) => {
  const activePathArr = [];
  [
    "/bank",
    "/retail",
    "/insurance",
    "/life",
    "/communication",
    "/energy",
    "/travel",
  ].includes(pathname) && activePathArr.push("industries");
  [
    "/aboutUs",
    "/leadership",
    "/partners",
    "/customers",
    "/successStories",
  ].includes(pathname) && activePathArr.push("overview");
  return activePathArr;
};

module.exports = { createMainMenu, createSubMenu, activeMenu };
